import { Column } from "@faire/web/slate/Layout";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";

export const NarrowContainer = styled(Column)`
  width: 100%;
  max-width: 744px;

  ${responsiveMediaQueries.mobile} {
    padding: 0px;
    width: calc(100% - 36px);
  }

  ${responsiveMediaQueries.tablet} {
    max-width: 648px;
  }
`;
